import React from 'react';

import SDGTableTHead from './SDGTableTHead';
import SDGTableTBody from './SDGTableTBody';

import formatTable from '../../helpers/formatTable';

class SDGTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.buildState(props.data);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.buildState(nextProps.data));
  }

  buildState(data) {
    const state = {
      tBodyData: [],
      tHeadData: []
    };

    if (Array.isArray(data)) {
      state.tHeadData = formatTable(data.slice(0, 2));
      state.tBodyData = formatTable(data.slice(2, data.length));
    }

    return state;
  }

  render() {
    const { className, title} = this.props;
    const { tBodyData, tHeadData } = this.state;

    return (
      <div className={ className }>
        <h2>{ title }</h2>
        <div className="sdg-table__container">
          <table className="table sdg-table">
            <SDGTableTHead data={ tHeadData } />
            <SDGTableTBody data={ tBodyData } />
          </table>
        </div>
      </div>
    );
  }
}

export default SDGTable;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGTable.js